import { depx as s } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { formatLength as i } from "../../_utils/css/format-length.js";
const a = 40, l = 40;
function O(e) {
  if (e.type === "selection")
    return e.width === void 0 ? a : s(e.width);
  if (e.type === "expand")
    return e.width === void 0 ? l : s(e.width);
  if (!("children" in e))
    return typeof e.width == "string" ? s(e.width) : e.width;
}
function y(e) {
  var n, t;
  if (e.type === "selection")
    return i((n = e.width) !== null && n !== void 0 ? n : a);
  if (e.type === "expand")
    return i((t = e.width) !== null && t !== void 0 ? t : l);
  if (!("children" in e))
    return i(e.width);
}
function w(e) {
  return e.type === "selection" ? "__n_selection__" : e.type === "expand" ? "__n_expand__" : e.key;
}
function C(e) {
  return e && (typeof e == "object" ? Object.assign({}, e) : e);
}
function b(e) {
  return e === "ascend" ? 1 : e === "descend" ? -1 : 0;
}
function x(e, n, t) {
  return t !== void 0 && (e = Math.min(e, typeof t == "number" ? t : Number.parseFloat(t))), n !== void 0 && (e = Math.max(e, typeof n == "number" ? n : Number.parseFloat(n))), e;
}
function m(e, n) {
  if (n !== void 0)
    return {
      width: n,
      minWidth: n,
      maxWidth: n
    };
  const t = y(e), {
    minWidth: f,
    maxWidth: u
  } = e;
  return {
    width: t,
    minWidth: i(f) || t,
    maxWidth: i(u)
  };
}
function W(e, n, t) {
  return typeof t == "function" ? t(e, n) : t || "";
}
function F(e) {
  return e.filterOptionValues !== void 0 || e.filterOptionValue === void 0 && e.defaultFilterOptionValues !== void 0;
}
function k(e) {
  return "children" in e ? !1 : !!e.sorter;
}
function N(e) {
  return "children" in e && e.children.length ? !1 : !!e.resizable;
}
function j(e) {
  return "children" in e ? !1 : !!e.filter && (!!e.filterOptions || !!e.renderFilterMenu);
}
function o(e) {
  if (e) {
    if (e === "descend")
      return "ascend";
  } else
    return "descend";
  return !1;
}
function E(e, n) {
  return e.sorter === void 0 ? null : n === null || n.columnKey !== e.key ? {
    columnKey: e.key,
    sorter: e.sorter,
    order: o(!1)
  } : Object.assign(Object.assign({}, n), {
    order: o(n.order)
  });
}
function I(e, n) {
  return n.find((t) => t.columnKey === e.key && t.order) !== void 0;
}
function g(e) {
  return typeof e == "string" ? e.replace(/,/g, "\\,") : e == null ? "" : `${e}`.replace(/,/g, "\\,");
}
function K(e, n, t, f) {
  const u = e.filter((r) => r.type !== "expand" && r.type !== "selection" && r.allowExport !== !1), p = u.map((r) => f ? f(r) : r.title).join(","), h = n.map((r) => u.map((d) => t ? t(r[d.key], r, d) : g(r[d.key])).join(","));
  return [p, ...h].join(`
`);
}
export {
  l as EXPAND_COL_WIDTH,
  a as SELECTION_COL_WIDTH,
  x as clampValueFollowCSSRules,
  m as createCustomWidthStyle,
  E as createNextSorter,
  W as createRowClassName,
  C as createShallowClonedObject,
  K as generateCsv,
  w as getColKey,
  b as getFlagOfOrder,
  O as getNumberColWidth,
  y as getStringColWidth,
  j as isColumnFilterable,
  N as isColumnResizable,
  k as isColumnSortable,
  I as isColumnSorting,
  F as shouldUseArrayInSingleMode
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/utils.js
// module id = 123
// module chunks = 41